'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsUtils = require('widgets-utils');

var _dropdown = require('dropdown');

var _constats = require('../utils/constats');

var _style = require('./../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecommendationsTab = function (_React$Component) {
    (0, _inherits3.default)(RecommendationsTab, _React$Component);

    function RecommendationsTab(props) {
        (0, _classCallCheck3.default)(this, RecommendationsTab);

        var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

        _this.getNextSlide = _this.getNextSlide.bind(_this);
        _this.getPrevSlide = _this.getPrevSlide.bind(_this);
        _this.changeSpecialist = _this.changeSpecialist.bind(_this);
        return _this;
    }

    RecommendationsTab.prototype.getSlideContent = function getSlideContent(recommendations) {
        var _this2 = this;

        var contentHeight = 65 + (this.props.showSpecialistImageInReview || this.props.showPracticeImageInReview ? 2 * 75 : 2 * 32); // 65px - base height, +2*75px - if we show specialistImages in "About Our Doctors" Tab or practiceImage in "About Our Practice", otherwise +2*32px.
        return recommendations.map(function (recommendation) {
            return _react2.default.createElement(
                'div',
                { className: _style2.default["recommendation-item"] },
                _react2.default.createElement(_widgetsUtils.RecommendationItem, (0, _extends3.default)({
                    key: recommendation.id,
                    contentStyle: { "height": contentHeight + 'px' },
                    wrapperStyle: { "background-color": _this2.props.recommendationItemBackground },
                    showFrame: _this2.props.recommendationItemFrame
                }, recommendation))
            );
        });
    };

    RecommendationsTab.prototype.getPrevSlide = function getPrevSlide() {
        return this.props.loadRecommendations(this.props.profileType === _constats.QUERY_SPECIALISTS_PROFILE_TYPE && this.props.profileId || this.props.activeSpecialist && this.props.activeSpecialist.id, 'prev', this.props);
    };

    RecommendationsTab.prototype.getNextSlide = function getNextSlide() {
        return this.props.loadRecommendations(this.props.profileType === _constats.QUERY_SPECIALISTS_PROFILE_TYPE && this.props.profileId || this.props.activeSpecialist && this.props.activeSpecialist.id, 'next', this.props);
    };

    RecommendationsTab.prototype.changeSpecialist = function changeSpecialist(targetSpecialist) {
        this.props.onLoading(this.props.changeSpecialist, targetSpecialist, this.props);
    };

    RecommendationsTab.prototype.render = function render() {
        return _react2.default.createElement(
            'div',
            { className: [_style2.default.tab, _style2.default["tab_recommendations"]].join(" ") },
            _react2.default.createElement(
                'div',
                { className: _style2.default["text-center"] },
                _react2.default.createElement(
                    'div',
                    { className: _style2.default["tab__info"] },
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default["patient-reviews-count"] },
                        _react2.default.createElement(_widgetsUtils.PatientsReviewsCount, {
                            reviewsCount: this.props.totalRecommendations,
                            postfix: ' Doctor Recommendation' + (this.props.totalRecommendations > 1 && 's' || ''),
                            isCountBold: true
                        })
                    ),
                    this.props.profileType !== _constats.QUERY_SPECIALISTS_PROFILE_TYPE && _react2.default.createElement(
                        'div',
                        { className: _style2.default["dropdown-container"] },
                        _react2.default.createElement(_dropdown.Dropdown, {
                            items: this.props.specialists,
                            readonly: true,
                            selectedItem: this.props.activeSpecialist,
                            onItemSelected: this.changeSpecialist,
                            placeholder: 'All doctors',
                            ItemRenderer: function ItemRenderer(rendererProps) {
                                var item = rendererProps.item;

                                return _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        item.name
                                    )
                                );
                            } })
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _style2.default["tab__slider"] },
                _react2.default.createElement(_widgetsUtils.WidgetCarousel, {
                    classNames: {
                        'wc': _style2.default.wc,
                        'wc__content': _style2.default["wc__content"],
                        'wc__arrow': _style2.default['wc__arrow'],
                        'wc__arrow--left': _style2.default["wc__arrow--left"],
                        'wc__arrow--right': _style2.default["wc__arrow--right"]
                    },
                    slides: this.getSlideContent(this.props.recommendations.slice(0, this.props.recommendationsLimit)),
                    nextSlide: this.getNextSlide,
                    prevSlide: this.getPrevSlide
                })
            )
        );
    };

    return RecommendationsTab;
}(_react2.default.Component);

exports.default = RecommendationsTab;